import { ROTULO_DO_TIPO_DE_EQUIPAMENTO, type ItemDaBaseEntrada } from "@bookdental/schemas";
import { cn } from "@/lib/cn";
import { SeletorDeChips } from "../SeletorDeChips";
import { Campo, CampoPerfis, SeletorDeQuimica, TextoComSugestoes, entradaCls, opcoesDeQuimica, type OpcoesDaBase } from "./comum";

type Insumo = Extract<ItemDaBaseEntrada, { tipo: "insumos" }>;

const TRANSLUCIDEZ = ["HT", "MT", "LT", "UT", "MULTICAMADA"];
const FORMATOS = ["Disco 98 mm", "Bloco", "Pastilha", "Pó + líquido", "Frasco", "Lingote", "Carela", "Placa", "Cartucho"];
const UNIDADES = ["UN", "g", "kg", "mL", "L"];
const CATEGORIAS = ["Blocos e discos", "Pastilhas", "Pós e líquidos cerâmicos", "Resinas", "Metais", "Dentes de estoque", "Gessos e revestimentos", "Ceras", "Brocas e fresas", "Polimento", "Químicos", "Placas"];

export function CamposInsumo({ item, mudar, opcoes }: { item: Insumo; mudar: (p: Partial<Insumo>) => void; opcoes: OpcoesDaBase }) {
  const equipamentos = opcoes.equipamentos.map((e) => ({
    id: e.id,
    rotulo: e.nome,
    grupo: ROTULO_DO_TIPO_DE_EQUIPAMENTO[e.tipo] ?? e.tipo,
    apagada: e.status !== "PUBLICADO",
  }));
  return (
    <>
      <Campo rotulo="Nome">
        <input value={item.nome} onChange={(e) => mudar({ nome: e.target.value })} className={entradaCls} />
      </Campo>
      <div className="grid gap-4 sm:grid-cols-2">
        <Campo rotulo="Tipo">
          <div className="inline-flex rounded-md border border-admin-200 p-0.5">
            {(["PRODUTO", "CONSUMIVEL"] as const).map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => mudar({ tipoDeInsumo: t })}
                aria-pressed={item.tipoDeInsumo === t}
                className={cn("rounded px-3 py-1 text-sm", item.tipoDeInsumo === t ? "bg-admin-900 text-white" : "text-admin-700 hover:bg-admin-50")}
              >
                {t === "PRODUTO" ? "Produto" : "Consumível"}
              </button>
            ))}
          </div>
        </Campo>
        <Campo rotulo="Fabricante">
          <TextoComSugestoes id="fabricantes" valor={item.fabricante} onChange={(fabricante) => mudar({ fabricante })} sugestoes={opcoes.fabricantes.map((f) => f.name)} />
        </Campo>
      </div>
      <Campo rotulo="Química" dica="Classifica o insumo no estoque do laboratório.">
        <SeletorDeQuimica opcoes={opcoes} valor={item.materialCategoryId} onChange={(materialCategoryId) => mudar({ materialCategoryId })} />
      </Campo>
      <div className="grid gap-4 sm:grid-cols-2">
        <Campo rotulo="Formato">
          <TextoComSugestoes id="formatos" valor={item.formato ?? ""} onChange={(formato) => mudar({ formato })} sugestoes={FORMATOS} />
        </Campo>
        <Campo rotulo="Translucidez">
          <select value={item.translucidez ?? ""} onChange={(e) => mudar({ translucidez: e.target.value || null })} className={entradaCls}>
            <option value="">Não se aplica</option>
            {TRANSLUCIDEZ.map((t) => (
              <option key={t} value={t}>
                {t === "MULTICAMADA" ? "Multicamada" : t}
              </option>
            ))}
          </select>
        </Campo>
        <Campo rotulo="Unidade">
          <TextoComSugestoes id="unidades" valor={item.unidade ?? ""} onChange={(unidade) => mudar({ unidade })} sugestoes={UNIDADES} />
        </Campo>
        <Campo rotulo="Categoria no estoque">
          <TextoComSugestoes id="categorias-estoque" valor={item.categoriaSugerida ?? ""} onChange={(categoriaSugerida) => mudar({ categoriaSugerida })} sugestoes={CATEGORIAS} />
        </Campo>
      </div>
      <Campo rotulo="Usado com" dica="Químicas de material em que o insumo é gasto (fresa de zircônia, ácido do dissilicato).">
        <SeletorDeChips opcoes={opcoesDeQuimica(opcoes)} valor={item.usadoComIds ?? []} onChange={(usadoComIds) => mudar({ usadoComIds })} />
      </Campo>
      <Campo rotulo="Equipamentos" dica="Máquinas que gastam o insumo — sugerem o insumo a quem tem a máquina.">
        <SeletorDeChips opcoes={equipamentos} valor={item.equipamentoIds ?? []} onChange={(equipamentoIds) => mudar({ equipamentoIds })} />
      </Campo>
      <CampoPerfis valor={item.perfis ?? []} onChange={(perfis) => mudar({ perfis })} />
    </>
  );
}
